import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/common-services/common-service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators'


@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
	@Input() bradcrumbsData: any;
	@Input() record: any;


	link: any;
	show: boolean = true;

	breadcrumbUrl: string[] = [];

	constructor(private commonService: CommonService, private route: ActivatedRoute, private router: Router) { }
	result: any;

	ngOnInit(): void {


		// console.log("record", this.record);
		
		if (this.record=== 0) {
			this.show = false;
		}

		// this.link = this.router.url;
		this.breadcrumbUrl = this.router.url.split("/");
	

	}
}
